import { useEffect, useState } from "react"
import ReactPlayer from 'react-player';
import { InView } from 'react-intersection-observer';
import { MediaController, MediaControlBar, MediaPlayButton, MediaTimeRange, MediaMuteButton } from "media-chrome/react";


export default function EventBody({ item }) {
    const [photo,setPhoto] = useState([]);
    const [vplay, setVplay] = useState(false);

    useEffect(()=>{
        if(item.files!==null){
            let jobs = JSON.parse(item.files);
            setPhoto(jobs);
        }
    },[]);

    return <div>
        {
            photo.length === 1 &&
            <div className="relative uk-visible-toggle sm:px-4" tabindex="-1">
                <div className="w-full overflow-hidden sm:rounded-md" uk-lightbox="video-autoplay: true">

                    
                        <a href={photo[0].path}
                           
                            data-caption="Caption" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                            <img src={photo[0].path} className="w-full inset-0" alt="" />
                        </a>
                    
                    {
                        photo[0].type === 'video' &&

                        <div
                            onClick={() => {
                                setVplay(!vplay);
                            }}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                            <InView as="div" onChange={(inView, entry) => {
                                setVplay(inView);
                            }}></InView>
                            <MediaController
                                style={{
                                    width: 468,
                                    height: 585
                                }}
                            >
                                <ReactPlayer
                                    src={photo[0].path}
                                    playing={vplay}
                                    playsInline={true}
                                    muted={false}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        "--controls": "none",
                                    }}
                                ></ReactPlayer>

                            </MediaController>
                            {
                                !vplay &&
                                <div style={{ position: 'absolute', top: 280, fontSize: 35, color: '#000' }}>
                                    <i class="fa fa-play-circle-o" aria-hidden="true"></i>
                                </div>
                            }
                        </div>

                    }

                </div>
            </div>
        }
        {
            photo.length > 1 &&

            <div className="relative uk-visible-toggle sm:px-4" tabindex="-1" uk-slideshow="animation: push;finite: true;min-height: 468; max-height: 468">

                <ul className="uk-slideshow-items" uk-lightbox="video-autoplay: true">
                    {
                        photo.map((p) =>
                            <li key={p.id} className="w-full overflow-hidden sm:rounded-md" style={{ background: p.type === 'video' ? '#000' : '#fff' }}>
                                <a href={p.path}
                                    
                                    data-caption="Caption" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                    {
                                        p.type === 'image' &&
                                        <img src={p.path} className="   inset-0" alt="" style={{ maxHeight: 468 }} />
                                    }
                                    {
                                        p.type === 'video' &&
                                        <img src={p.poster} className="   inset-0" alt="" />
                                    }
                                </a>
                                {
                                    p.type === 'video' &&

                                    <a href={p.path + '?autoplay=1'}
                                        
                                        className="text-center items-center" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, alignContent: 'center' }}>
                                        <button type="button" class="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                            <svg class="w-6 h-6 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m2.707 14.293 5.586-5.586a1 1 0 0 0 0-1.414L2.707 1.707A1 1 0 0 0 1 2.414v11.172a1 1 0 0 0 1.707.707Z" />
                                            </svg>
                                            <span class="sr-only">Icon description</span>
                                        </button>
                                    </a>
                                }
                            </li>
                        )
                    }

                </ul>


                <button type="button" className="absolute left-2 -translate-y-1/2 bg-black/40 backdrop-blur-3xl rounded-full top-1/2 grid w-7 h-7 place-items-center shadow" uk-slideshow-item="previous">
                    <ion-icon name="chevron-back" className="text-xl text-white">
                        <i className="fa fa-angle-left"></i>
                    </ion-icon></button>
                <button type="button" className="absolute right-2 -translate-y-1/2 bg-black/40 backdrop-blur-3xl rounded-full top-1/2 grid w-7 h-7 place-items-center shadow" uk-slideshow-item="next">
                    <ion-icon name="chevron-forward" className="text-xl text-white">
                        <i className="fa fa-angle-right"></i>
                    </ion-icon></button>

            </div>
        }
    </div>
}